import { omit } from 'ramda';
import { IOfferState } from '../../../../../shared/redux/reducers';

export const premoderationClean = (offer: IOfferState): IOfferState => {
  if (offer.isEnabledCallTracking === null) {
    return omit(['isEnabledCallTracking'], offer);
  }

  return offer;
};
